import React, {useState} from 'react';
import s from "./LinkedInPostPreview.module.css";
import menu from "../../../../assets/img/menu.svg";
import reaction1 from "../../../../assets/img/Group.svg";
import reaction2 from "../../../../assets/img/Group1.svg";
import reaction3 from "../../../../assets/img/Group2.svg";
import like from "../../../../assets/img/like.svg";
import comment from "../../../../assets/img/comment.svg";
import share from "../../../../assets/img/share.svg";
import send from "../../../../assets/img/send.svg";
interface LinkedInPostPreviewProps {
    image: string | null;
    text: string ;
    highlightHashtags:(text:string)=>void
}

const LinkedInPostPreview: React.FC<LinkedInPostPreviewProps> = ({image,text,highlightHashtags}) => {
    const [showFullText, setShowFullText] = useState<boolean>(false);
    const maxPreviewLength = 250;

    const toggleFullText = () => {
        setShowFullText(!showFullText);
    };
    return (
        <div className={s.preview}>
            <div className={s.profileSection}>
                <div style={{display: 'flex'}}>
                    <span className={s.profileImage}></span>
                    <div className={s.profileDetails}>
                        <div className={s.profileName}></div>
                        <div className={s.profileTitle}></div>

                    </div>
                </div>

                <img src={menu} className={s.menu} alt="Menu"/>
            </div>

            <div className={s.content}>
                {!showFullText && text.length > maxPreviewLength ? (
                    <>
                        {highlightHashtags(text.slice(0, maxPreviewLength))}
                        <button onClick={toggleFullText} className={s.readMoreButton}>
                            ...see more
                        </button>
                    </>
                ) : (
                    <>
                        {highlightHashtags(text)}
                        {text.length > maxPreviewLength && (
                            <button onClick={toggleFullText} className={s.readMoreButton}>
                                ...see less
                            </button>
                        )}
                    </>
                )}
            </div>
            {image &&
                <div className={s.imageList}>

                    <img src={image} className={s.uploadedImage}/>
                    {/*{images.map((image, index) => (*/}
                    {/*    <img key={index} src={image} alt={`Uploaded ${index}`} className={s.uploadedImage}/>*/}
                    {/*))}*/}
                </div>}


            <div className={s.commentsSharesSection}>
                <div className={s.commentShareRow}>
                    <div className={s.reactionIcon}>
                        <img src={reaction1} className={s.reaction}/>
                        <img src={reaction2} className={s.reaction}/>
                        <img src={reaction3} className={s.reaction}/>
                        <div className={s.likeCount}>276</div>
                    </div>

                    <div className={s.details}>
                        <div className={s.commentsCount}>8 comments</div>
                        <div className={s.separator}>•</div>
                        <div className={s.sharesCount}>1 reposts</div>
                    </div>
                </div>
                <div className={s.actionButtons}>
                    <div className={s.actionButton}>
                        <img src={like} alt="Like"/>
                        <p>Like</p>
                    </div>
                    <div className={s.actionButton}>
                        <img src={comment} alt="Comment"/>
                        <p>Comment</p>
                    </div>
                    <div className={s.actionButton}>
                        <img src={share} alt="Repost"/>
                        <p>Repost</p>
                    </div>
                    <div className={s.actionButton}>
                        <img src={send} alt="Send"/>
                        <p>Send</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LinkedInPostPreview;
